const footerNotification = () => {
	document.addEventListener('DOMContentLoaded', () => {
		const footerNotificationBanner = document.getElementById('footer-notification-banner');

		if (footerNotificationBanner) {
			const closeBtn = document.querySelector('.footer-notification-banner__close-btn');
			const browserStorageKey = 'ceFooterNotificationShownDate';
			let manuallyClosedToday = false;

			let todayDate = new Date();
			const offset = todayDate.getTimezoneOffset();
			todayDate = new Date(todayDate.getTime() - (offset * 60 * 1000));
			const localTodayDate = todayDate.toISOString().split('T')[0];

			const lastShownDate = localStorage.getItem(browserStorageKey);

			if (lastShownDate === localTodayDate) {
				manuallyClosedToday = true;
			}

			closeBtn.addEventListener('click', (e) => {
				e.stopPropagation();
				manuallyClosedToday = true;
				footerNotificationBanner.classList.remove('show');
				localStorage.setItem(browserStorageKey, localTodayDate);
			});

			footerNotificationBanner.addEventListener('click', (e) => {
				e.stopPropagation();
			});

			window.addEventListener('scroll', () => {
				if (manuallyClosedToday) {
					return;
				}

				const { scrollY: verticalScroll } = window;

				if (verticalScroll > 1) {
					footerNotificationBanner.classList.add('show');
				} else {
					footerNotificationBanner.classList.remove('show');
				}
			});
		}
	});
};

export default footerNotification;
